import { app as microsoftTeams, authentication as teamsAuthentication } from '@microsoft/teams-js';
let initialized = false;

export const teamsGetApi = () => {
  if (!initialized) {
    microsoftTeams.initialize();
    initialized = true;
  }

  return microsoftTeams;
};

export const getTeamsAuthentication = () => {
  return teamsAuthentication;
};

export const teamsContext = async () => {
  const api = teamsGetApi();
  return await api.getContext();
};

export const teamsContextExec = async (callback) => {
  const context = await teamsContext();
  callback(context);
};

export const checkInTeams = () => {
  const microsoftTeamsLib = microsoftTeams || window['microsoftTeams'];

  if (!microsoftTeamsLib) {
    return false;
  }

  if (
    (window.parent === window.self && window.nativeInterface) ||
    window.navigator.userAgent.includes('Teams/') ||
    window.name === 'embedded-page-container' ||
    window.name === 'extension-tab-frame' ||
    window.self !== window.top
  ) {
    return true;
  }

  return false;
};

export const isInTeamsChannel = () => {
  return new Promise((resolve) => {
    if (checkInTeams()) {
      teamsContextExec((context) => {
        resolve(!!context.channelId);
      });
    } else {
      resolve(false);
    }
  });
};
